import { z } from "zod";

export const feedbackSearchSchema = z.object({
    rating: z.coerce.number().int().min(1).max(5).optional().catch(undefined),
    campaign: z.string().optional().catch(undefined),
});
